import React, { useEffect, useState } from 'react'
import { connect } from '@cerebral/react'
import { sequences, state } from 'cerebral'
import { TextField, InputAdornment, Icon } from '@mui/material'

const Search = connect(
  {
    setSearch: sequences`route.setSearch`,
    search: state`route.params.$search`,
  },

  ({ setSearch, search, placeholder = 'Search' }) => {
    const searchText = search?.[0] || ''
    const [value, setValue] = useState(searchText)

    useEffect(() => {
      setValue(searchText)
    }, [searchText])

    return (
      <TextField
        variant="outlined"
        margin="none"
        placeholder={placeholder}
        value={value}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Icon>search</Icon>
              </InputAdornment>
            ),
          },
        }}
        onChange={({ target: { value } }) => {
          setValue(value)
          setSearch({ search: [value] })
        }}
      />
    )
  }
)

export default Search
